/**
 * Viri knjizb: programi, iz katerih pride izvoz glavne knjige.
 *
 * Vir je lastnost podjetja in se izbere ob ustvarjanju, ob nalaganju izvoza
 * pa se ne spreminja (docs/ARHITEKTURA.md, 5.2). Seznam je tu, ker ga
 * potrebujeta oba dela aplikacije: vmesnik za izbiro in nazive, streznik za
 * preverjanje in sporocila. Prej je bil zapisan na treh mestih posebej in se
 * je razsel - vmesnik je Minimax se vedno ponujal kot nepodprt, ko je uvoz
 * zanj ze deloval.
 */
/**
 * Vsi viri, ki jih aplikacija pozna.
 *
 * Ko zazivi uvoz za nov vir, se tu prestavi `uvozPodprt` na `true`; test
 * `viri.test.ts` na strani streznika preveri, da se zastavica ujema z
 * dejanskim seznamom prevajalnikov.
 */
export const VIRI = [
    { koda: 'pantheon', naziv: 'Pantheon', uvozPodprt: true, otvoritevIzBilance: false },
    { koda: 'minimax', naziv: 'Minimax', uvozPodprt: true, otvoritevIzBilance: false },
    { koda: 'bc', naziv: 'Business Central', uvozPodprt: true, otvoritevIzBilance: true },
];
/** Ali vir zahteva loceno nalaganje otvoritve iz bruto bilance. */
export function potrebujeOtvoritevIzBilance(koda) {
    return VIRI.find((v) => v.koda === koda)?.otvoritevIzBilance === true;
}
/** Naziv vira za prikaz; `undefined`, kadar vira ne poznamo. */
export function nazivVira(koda) {
    return VIRI.find((v) => v.koda === koda)?.naziv;
}
/** Vir, ki pri podjetju velja za dano leto. */
export function virZaLetoIzObdobij(obdobja, leto) {
    let vir;
    for (const o of obdobja) {
        if (o.odLeta === null || o.odLeta <= leto)
            vir = o.vir;
    }
    return vir;
}
//# sourceMappingURL=viri.js.map